export enum VisionPercentFormatType {
  DOT_RIGHT = 'dotRight',
  COMMA_RIGHT = 'commaRight',
  COMMA_LEFT = 'commaLeft',
}
